import {formatPrice, Variant} from "../../models/product";
import {Component, ComponentChild, h, RenderableProps} from "preact";

interface Props {
  styles: { [key: string]: string };
  variant: Variant;
}

export class ProductPrice extends Component<Props, any> {
  render({variant, styles}: RenderableProps<Props>): ComponentChild {
    if (!variant.showPriceLabel()) return null;

    return (
      <div class={styles["price-container"]}>
        {variant.sale ? (
          <div className={styles["sale-container"]}>
            <div className={styles["sale-price-container"]}>
              {variant.showOriginalLocal() && (
                <span className={styles["original-price"]}>
                  {formatPrice(variant.originalPrice, variant.currency)}
                </span>
              )}

              <span
                className={
                  variant.showOriginalLocal()
                    ? styles["sale-price-with-original-price"]
                    : styles["sale-price"]
                }
              >
                {formatPrice(variant.currentPrice, variant.currency)}
              </span>
            </div>

            {variant.hasExchangePrice() && (
              <div className={styles["original-price-container"]}>
                {variant.showOriginalExchange() && (
                  <span className={styles["original-price"]}>
                    {formatPrice(variant.originalExchangePrice!, variant.exchangeCurrency!)}
                  </span>
                )}

                <span
                  className={
                    variant.showOriginalExchange()
                      ? styles["sale-price-with-original-price"]
                      : styles["sale-price"]
                  }
                >
                  {formatPrice(variant.currentExchangePrice!, variant.exchangeCurrency!)}
                </span>
              </div>
            )}
          </div>
        ) : (
          <div class={styles["current-price-container"]}>
            <span>{formatPrice(variant.currentPrice, variant.currency)}</span>

            {variant.hasExchangePrice() && (
              <span class={styles["current-exchange-price"]}>
                {formatPrice(variant.currentExchangePrice!, variant.exchangeCurrency!)}
              </span>
            )}
          </div>
        )}
      </div>
    );
  }
}
